import styled from '@emotion/styled';
import * as main from '@shared/styles/abstracts/vars.module.scss';
import { Card } from '@shared/ui/index';

export const SCard = styled(Card)`
  transition: transform 0.1s ease-in-out;

  display: flex;
  flex-direction: row;
  padding: 10px;
  max-width: 1140px;
  min-width: 188px;
  max-height: 111px;
  margin-bottom: 10px;
  &:hover {
    transform: scale(1.02);
    cursor: pointer;
  }
`;

export const SConsultationCost = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: auto;
  color: ${main.colorActive};

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    position: relative;
    bottom: -1px;
    margin-left: 7px;

    @media (width < ${main.brpMobile}) {
      display: none;
    }
  }
`;

export const SCountOfAvailableConsultations = styled.div`
  background: ${main.colorBgPrimary};
  border-radius: 50%;
  width: 34px;
  height: 34px;
  margin-left: auto;
  align-content: center;
  text-align: center;
  color: ${main.colorActive};
`;

export const SAdditionalInfo = styled.section`
  display: flex;
  flex-direction: column;
  margin-left: auto;
`;

export const SCity = styled.span`
  margin-top: auto;

  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;

  @media (width < ${main.brpMobile}) {
    max-height: 57px;
    max-width: 52px;
  }
`;
export const SHomeIconMenu = styled.div`
  margin-left: 10px;
`;
